import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  LogoLoader,
  NewTableAdv,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
} from "../../../components";
import qbLoading from "../../../assets/qbLoading.svg";
import { mapTableRows } from "../../../utils";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { WORKFORCE_API_URL } from "../../../redux/apiConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  clearCurrentProfile,
  setQbProfile,
} from "../../../redux/slices/quickBooks/quickBooksSlice";

const QbIntegrationProfiles = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const [tableData2, setTableData2] = useState([]);
  const [isStateLoading, setIsStateLoading] = useState(false);
  console.log("tableData2", tableData2);

  //on connection redirect message
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stateParam = params.get("state");
    if (stateParam) {
      try {
        const decoded = JSON.parse(atob(stateParam));
        showToast(`${decoded.message}`, "success", 4000);
      } catch (err) {
        console.error("Failed to decode state param:", err);
      }
    }
  }, []);

  //ref
  // const tableData = [
  //   {
  //     companyName: "Tek Tree LLC",
  //     integrationType: "Quick Books Online",
  //     status: "Connected",
  //     applicableBU: "Tektree",
  //   },
  // ];

  //fetching profiles
  useEffect(() => {
    const fetchConnections = async () => {
      try {
        setIsStateLoading(true);
        const res = await axios.get(
          // `${WORKFORCE_API_URL}/authtokens/quickbooks&lim=100`,
          `${WORKFORCE_API_URL}/integrations/quickbooks?ret=companyName intType tokenExpiry isDefault userId`,
          { withCredentials: true }
        );
        console.log("res for auth ", res);
        if (res.status === 204) {
          setTableData2([]);
          dispatch(clearCurrentProfile());
        } else {
          setTableData2(res?.data?.data || []);
          const currentProfileData = res?.data?.data?.find(
            (item) => item.isDefault === true
          );
          dispatch(setQbProfile(currentProfileData));
        }
      } catch (err) {
        if (err.status === 404) {
          showToast("No connections found", "info", 2000);
        }
        console.error("Failed to fetch auth tokens", err);
      } finally {
        setIsStateLoading(false);
      }
    };

    fetchConnections();
  }, []);

  const columns = [
    {
      key: "companyName",
      label: "Company Name",
      render: (row) => (
        <div className={row.isDefault ? "text-linkblue" : ""}>
          {row?.companyName || "-"}
        </div>
      ),
    },
    {
      key: "integrationType",
      label: "Integration Type",
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
    },
    // {
    //   key: "applicableBU",
    //   label: "Applicable BU",
    // },
    {
      key: "Actions",
      label: "Actions",
      render: (row) => (
        <div className="cursor-pointer">
          <Avatar
            src={qbLoading}
            alt=""
            outline
            className="border-none"
            size="xs"
          />
        </div>
      ),
    },
  ];

  //mapping
  const mappedRows = mapTableRows(
    Array.isArray(tableData2)
      ? tableData2
          .filter((item) => item && typeof item === "object")
          .map((item) => ({
            companyName: item?.companyName || "",
            integrationType: item?.intType || "",
            status:
              new Date(item?.tokenExpiry) > new Date()
                ? "Connected"
                : "Disconnected",
            applicableBU: "-",
            isDefault: item?.isDefault || false,
          }))
          .reverse()
      : [],
    columns
  );
  //connection window
  const connectToQB = () => {
    if (loginUserUiid) {
      const isDefault = Array.isArray(tableData2) && tableData2.length === 0;
      const state = JSON.stringify({
        userId: loginUserUiid,
        isDefault,
      });
      console.log("isDefault", isDefault);
      const encodedState = encodeURIComponent(state);
      window.location.href = `${WORKFORCE_API_URL}/qb/auth?state=${encodedState}`;
    }
  };

  return (
    <div className="py-8 px-3">
      <Backdrop isOpen={isStateLoading}>
        <LogoLoader />
      </Backdrop>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"QuickBooks Integration Profiles"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <button
                className="flex border border-1px-newtrals gap-2 items-center px-2 rounded-md py-1 cursor-pointer"
                onClick={() => connectToQB()}
              >
                <p className="sub-category-meadium font-medium">
                  Connect To QUICKBOOKS
                </p>
                <Avatar
                  src={qbLoading}
                  alt=""
                  outline
                  className="border-none"
                  size="xs"
                />
              </button>
              <Button
                title="Back"
                size="sm"
                icon={"arrow_left_alt"}
                onClick={() => navigate("/quickbooks")}
              />
            </>
          }
        />
      </div>
      <div>
        <NewTableAdv columns={columns} rows={mappedRows} hideToolBar />
      </div>
    </div>
  );
};

export default QbIntegrationProfiles;
